import { useState, useEffect } from "react";
import styles from "./mybooking.module.css";
import { MenuItem, Dialog, DialogTitle, DialogContent, FormControl, InputLabel, Select, Snackbar, Alert, Button, DialogActions, DialogContentText } from "@mui/material";
import { Close } from "@mui/icons-material";
import { Calendar, X } from "react-feather";
import axios from "axios";
import { authData } from "../../../admin/components/GetAuth";
import Loader from "../../../admin/components/Loader";
import SideBar from "../../components/sideBar";
import { TableLoader } from "../../components/ContentLoader";
import { DateRangePicker } from "rsuite";
import dayjs from "dayjs";
import TablePaginationComponent from "../../../admin/components/TablePagination";
import BookingBlock from "./components/BookingBlock";
import BookingDetailsPopup from "../../../admin/pages/booking/booking-list/bookingDetailsPopup";
import download from "downloadjs";

const MyBookings = () => {
  const auth = authData();
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(true);
  const [bookingList, setBookingList] = useState([]);
  const [allBookingList, setAllBookingList] = useState([]);
  const [filterVars, setFilterVars] = useState({ searchKey: "", status: "", date: null });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [viewModalOpen, setViewModalOpen] = useState();
  const [viewId, setViewId] = useState(0);
  const [viewStr, setViewStr] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");
  const [sendInvoiceModalOpen, setSendInvoiceModalOpen] = useState(false);
  const [invoiceMailId, setInvoiceMailId] = useState(0);
  const [invoiceMail, setInvoiceMail] = useState('');
  const [cancelModalOpen, setCancelModalOpen] = useState();
  const [cancelId, setCancelId] = useState(0);

  const paginationChangePage = (event, newPage) => {
    setPage(newPage);
  }

  const paginationChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }

  useEffect(() => {
    axios.get(process.env.REACT_APP_API_URL + "v1/customer/customer-booking-list", {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then((response) => {
      setContentLoading(false);
      if (response.data.status === "SUCCESS") {
        setAllBookingList(response?.data.data);
      }
    }).catch((error) => {
      setContentLoading(false);
    });
  }, [auth?.api_token]);

  useEffect(() => {
    let allBookingListTemp = allBookingList;

    if (filterVars?.searchKey !== "") {
      let inputVal = filterVars?.searchKey;
      inputVal = inputVal.toLowerCase();
      allBookingListTemp = allBookingListTemp.filter((item) => {
        return (item.booking_id.toLowerCase().includes(inputVal) || item.customer_name.toLowerCase().includes(inputVal) || item.post_code.toLowerCase().includes(inputVal) || item.created_user.toLowerCase().includes(inputVal));
      });
    }

    if (filterVars?.status !== "" && filterVars?.status !== "all") {
      let status = parseInt(filterVars?.status);
      allBookingListTemp = allBookingListTemp.filter((i) => parseInt(i?.status) === status);
    }

    if (filterVars?.date) {
      allBookingListTemp = allBookingListTemp.filter((i) => dayjs(i?.booking_date).isBetween(dayjs(filterVars?.date[0]).format("YYYY-MM-DD"), dayjs(filterVars?.date[1]).format("YYYY-MM-DD"), "day", "[]"));
    }

    setBookingList(allBookingListTemp);
  }, [allBookingList, filterVars]);

  const sendMailBooking = () => {
    setSendInvoiceModalOpen(false);
    setLoading(true);
    axios(process.env.REACT_APP_API_URL + 'v1/send-booking-pdf/' + invoiceMailId, {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then(response => {
      if (response.data.status === 'SUCCESS') {
        setLoading(false);
        setSnackbarOpen(true);
        setSnackbarMessage(response.data.message);
        setSnackbarType("success");
      } else {
        setLoading(false);
      }
    }).catch(error => {
      setLoading(false);
    });
  }

  const printBooking = (id) => {
    setLoading(true);
    axios(process.env.REACT_APP_API_URL + "v1/bookings-item-pdf/" + id, {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then((response) => {
      setLoading(false);
      const content = response.headers["content-type"];
      download(response.data, "booking-" + id + ".pdf", content);
    }).catch((error) => {
      setLoading(false);
    });
  }

  const cancelBooking = () => {
    setLoading(true);
    setCancelModalOpen(false);

    axios.put(process.env.REACT_APP_API_URL + "v1/bookings/" + cancelId, { status: -1 }, {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then((response) => {
      setLoading(false);
      if (response.data.status === "SUCCESS") {
        setSnackbarOpen(true);
        setSnackbarMessage("Booking cancelled successfully.");
        setSnackbarType("success");

        setAllBookingList((prev) => {
          return prev.map((i) => {
            if (i?.id === cancelId) {
              return { ...i, status: -1 };
            }
            return i;
          });
        });

        setCancelId(0);
      }
    }).catch((error) => {
      setLoading(false);
    });
  }

  return (<>
    <Loader open={loading} setOpen={setLoading.bind(this)} />

    <div className={`${styles.MainDivCustomer}`}>
      <div className={`${styles.Container}`}>
        <div className={`${styles.CusRow}`}>
          <div className={`${styles.CustomerSideBar}`}><SideBar /></div>
          <div className={`${styles.CustomerDeSec}`}>
            <div className={`${styles.UserProCard2}`}>
              {contentLoading && <TableLoader />}

              {!contentLoading && <div className={`${styles.BookingCard}`}>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <div className={`${styles.BookListSearch}`}>
                    <input type="text" placeholder="Search booking list" value={filterVars?.searchKey} onChange={(e) => setFilterVars((prev) => { return { ...prev, searchKey: e.target.value }; })} />
                    {filterVars?.searchKey !== "" && (<button type="button" onClick={(e) => setFilterVars((prev) => { return { ...prev, searchKey: "" }; })}><Close /></button>)}
                  </div>
                  <div className={`CusSelectFilter Filter`} style={{ width: '30%' }}>
                    <FormControl fullWidth>
                      <InputLabel>Filter By Status</InputLabel>
                      <Select value={filterVars?.status} label="Filter By Status" onChange={(e) => setFilterVars((prev) => { return { ...prev, status: e.target.value }; })}>
                        <MenuItem value={"all"}>All</MenuItem>
                        <MenuItem value={-1}>Order Cancelled - UK</MenuItem>
                        <MenuItem value={0}>Order Booked - UK</MenuItem>
                        <MenuItem value={1}>Item Assigned To Driver - UK</MenuItem>
                        <MenuItem value={2}>Item Picked Up - UK</MenuItem>
                        <MenuItem value={3}>Item In Warehouse - UK</MenuItem>
                        <MenuItem value={4}>Item Shipped From Warehouse - UK</MenuItem>
                        <MenuItem value={5}>Item Received In Warehouse - Ghana</MenuItem>
                        <MenuItem value={6}>Item Out For Delivery - Ghana</MenuItem>
                        <MenuItem value={7}>Delivered - Ghana</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div style={{ width: '25%' }}>
                    <div className={`DashFilterSec`}>
                      <DateRangePicker format={"dd/MM/yyyy"} placement={"bottomEnd"} placeholder="Serach by date" caretAs={Calendar} value={filterVars?.date} showOneCalendar onChange={(e) => setFilterVars((prev) => { return { ...prev, date: e }; })} />
                    </div>
                  </div>
                </div>

                {bookingList?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)?.map((item, index) => {
                  return (<BookingBlock
                    key={index}
                    item={item}
                    setViewModalOpen={setViewModalOpen.bind(this)}
                    setViewId={setViewId.bind(this)}
                    setViewStr={setViewStr.bind(this)}
                    setSendInvoiceModalOpen={setSendInvoiceModalOpen.bind(this)}
                    setInvoiceMailId={setInvoiceMailId.bind(this)}
                    setInvoiceMail={setInvoiceMail.bind(this)}
                    printBooking={printBooking.bind(this)}
                    setCancelId={setCancelId.bind(this)}
                    setCancelModalOpen={setCancelModalOpen.bind(this)}
                  />);
                })}

                {bookingList?.length > 0 && (<TablePaginationComponent
                  count={bookingList?.length}
                  colSpan={6}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  handleChangePage={paginationChangePage}
                  handleChangeRowsPerPage={paginationChangeRowsPerPage}
                />)}

                {bookingList?.length === 0 && (<div className={`${styles.NofileSec}`}>
                  <div className={`${styles.NofileSecUnder}`}>
                    <img src="/images/no-connection.png" alt="" />
                    <p>No booking are available now</p>
                  </div>
                </div>)}

              </div>}
            </div>
          </div>
        </div>
      </div>
    </div>

    <Dialog
      fullWidth
      maxWidth="md"
      className="NewPopUp"
      open={viewModalOpen}
      onClose={(e) => setViewModalOpen(false)}
    >
      <DialogTitle id="alert-dialog-title">
        Order Information: #{viewStr}
        <button onClick={(e) => setViewModalOpen(false)}><X /></button>
      </DialogTitle>
      <DialogContent>
        <BookingDetailsPopup bookingId={viewId} />
      </DialogContent>
    </Dialog>

    <Dialog
      open={sendInvoiceModalOpen}
      onClose={(e) => setSendInvoiceModalOpen(false)}
      fullWidth
      maxWidth="xs"
      className="NewPopUp"
    >
      <DialogTitle id="alert-dialog-title">
        {"Send Invoice?"}
        <button onClick={(e) => setSendInvoiceModalOpen(false)}><X /></button>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <div className="ModalFormGroup">
            <label className="PopupBodyText">Are you sure to send invoice to <strong>{invoiceMail}</strong>?</label>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button className="CancelPopupBU" onClick={(e) => setSendInvoiceModalOpen(false)}>Cancel</Button>
        <Button className="SubmitPopupBU" onClick={(e) => sendMailBooking()}>Confirm</Button>
      </DialogActions>
    </Dialog>

    <Dialog
      open={cancelModalOpen}
      onClose={(e) => setCancelModalOpen(false)}
      fullWidth
      maxWidth="xs"
      className="NewPopUp"
    >
      <DialogTitle id="alert-dialog-title">
        {"Cancel Booking?"}
        <button onClick={(e) => setCancelModalOpen(false)}><X /></button>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <div className="ModalFormGroup">
            <label className="PopupBodyText">Are you sure to cancel this item?</label>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button className="CancelPopupBU" onClick={(e) => setCancelModalOpen(false)}>Cancel</Button>
        <Button className="SubmitPopupBU" onClick={(e) => cancelBooking()}>Confirm</Button>
      </DialogActions>
    </Dialog>

    <Snackbar
      open={snackbarOpen}
      autoHideDuration={6000}
      onClose={(e) => setSnackbarOpen(false)}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={(e) => setSnackbarOpen(false)}
        severity={snackbarType}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {snackbarMessage}
      </Alert>
    </Snackbar>
  </>);
};

export default MyBookings;